"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Instance = exports.createHasuraBackendPlus = void 0;
__exportStar(require("./composables"), exports);
var instance_1 = require("./instance");
Object.defineProperty(exports, "createHasuraBackendPlus", { enumerable: true, get: function () { return instance_1.createHasuraBackendPlus; } });
Object.defineProperty(exports, "Instance", { enumerable: true, get: function () { return instance_1.Instance; } });
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map